<template>
  <div>
    <el-collapse :accordion="true">
      <el-collapse-item v-for="(itemCycle, name) in lifeCycleData" :title="getCycleName(name)" :key="name">
        <div class="item">
          <div class="select_box">
            <cx-select :value.sync="selectData" :selectOptions="baseSelectOpt" />
            <p @click="addMovement(name)" class="add icon-portal-round-add"></p>
          </div>
          <transition-group tag="div" name="list" :ref="name">
            <div
              v-for="(itemMovement, index) in itemCycle"
              class="mt8 item_movement item_movement_content"
              :key="itemMovement.id"
            >
              <p class="icon_box">
                <span
                  @mousedown="dragStart(itemMovement, index, name, $event)"
                  class="icon-portal-drag-move drag_icon mr8"
                ></span>
                <span @click="del(index, name)" class="icon-portal-delete1 drag_icon"></span>
              </p>
              <span class="mr8 movementDes">任务类型</span>
              <span class="suffix_text">{{ taskMap[itemMovement.type] }}</span>
              <div v-if="itemMovement.type === 'plugin'">
                <div class="set_movement_item">
                  <p class="mr8 movementDes">插件名</p>
                  <el-input
                    :value="itemMovement.pluginName"
                    @input="updateMovement(name, index, 'pluginName', $event)"
                    placeholder="请输入插件名"
                  ></el-input>
                </div>
              </div>
              <div v-else-if="itemMovement.type === 'delay'">
                <div class="set_movement_item">
                  <p class="mr8 movementDes">延迟时间</p>
                  <single-input
                    :value.sync="itemMovement.time"
                    :noInputSuffixs="true"
                    @input="updateMovement(name, index, 'time', $event)"
                  />
<!--                  <el-input-->
<!--                    type="number"-->
<!--                    :minlength="0"-->
<!--                    :value="itemMovement.time"-->
<!--                    @input="updateMovement(name, index, 'time', $event)"-->
<!--                  />-->
                </div>
              </div>
            </div>
          </transition-group>
          <div
            v-if="wrapper"
            class="mt8 item_movement"
            :style="{
              left: left + 'px',
              top: top + 'px',
              width: width + 'px',
              top: top + 'px',
              position: 'fixed'
            }"
          >
            <p class="icon_box">
              <span class="icon-portal-drag-move drag_icon mr8"></span>
              <span class="icon-portal-delete1 drag_icon"></span>
            </p>
            <span class="mr8 movementDes">任务类型</span>
            <span class="suffix_text">{{ taskMap[wrapper.type] }}</span>
            <div v-if="wrapper.type === 'plugin'">
              <div class="set_movement_item">
                <p class="mr8 movementDes">插件名</p>
                <el-input
                  :value="wrapper.pluginName"
                  @input="updateMovement(name, index, 'pluginName', $event)"
                  placeholder="请输入插件名"
                ></el-input>
              </div>
            </div>
            <div v-else-if="wrapper.type === 'delay'">
              <div class="set_movement_item">
                <p class="mr8 movementDes">延迟时间</p>
                <single-input
                  :value.sync="wrapper.time"
                  :noInputSuffixs="true"
                  @input="updateMovement(name, index, 'time', $event)"
                />
<!--                <el-input-->
<!--                  type="number"-->
<!--                  :minlength="0"-->
<!--                  :value="wrapper.time"-->
<!--                  @input="updateMovement(name, index, 'time', $event)"-->
<!--                />-->
              </div>
            </div>
          </div>
          <div class="mt16 save_box padding0">
            <div v-show="itemCycle.length" @click="save(name)" class="save_edit">保存</div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { EventLifeCycle } from "utils/event"
import { _throttle } from "utils"
import { v1 } from "uuid"
const uuid = { v1 }
export default {
  props: {
    lifeCycle: [undefined, Object],
    tarEvent: Object
  },
  data() {
    return {
      lifeCycleData: null,
      selectData: "delay",
      componentSelectOpt: [
        {
          label: "更新响应组件数据",
          value: "toFetch"
        }
      ],
      baseSelectOpt: [
        {
          label: "延迟",
          value: "delay"
        },
        {
          label: "更新触发组件数据",
          value: "fromFetch"
        },
        {
          label: "插件",
          value: "plugin"
        }
      ],
      taskMap: {
        toFetch: "更新响应组件数据",
        fromFetch: "更新触发组件数据",
        delay: "延迟",
        plugin: "插件"
      },
      dragRefName: null,
      wrapper: null,
      nextEvent: null,
      dragId: null,
      left: 0,
      top: 0,
      width: 0,
      height: 0,
      leftFix: 0,
      topFix: 0
    }
  },
  methods: {
    fixSize(e) {
      const el = this.$el.getElementsByClassName("item_movement")[0]
      this.width = el.offsetWidth
      this.height = el.offsetHeight
      this.leftFix = e.offsetX
      this.topFix = e.offsetY
    },
    del(index, name) {
      this.lifeCycleData[name].splice(index, 1)
    },
    dragStart(tarEvent, index, name, e) {
      this.dragRefName = name
      this.wrapper = tarEvent
      this.nextCycleMovement = this.lifeCycleData[this.dragRefName][index + 1]
      this.dragId = tarEvent.id
      //先删除 后插入
      this.lifeCycleData[this.dragRefName].splice(index, 1)
      this.fixSize(e)
      this.setPosition(e)
      window.addEventListener("mousemove", this.dragMove)
      window.addEventListener("mouseup", this.drop)
    },
    dragMove: _throttle(function (e) {
      this.setPosition(e)
    }, 50),
    drop(e) {
      this.changeEventPosition(e)
      this.removeEventListener()
      this.dragId = ""
      this.dragRefName = ""
      this.width = null
      this.top = null
      this.wrapper = null
      this.nextCycleMovement = null
    },
    changeEventPosition(e) {
      const { eventType, eventNameDes: eventName, event } = this.wrapper
      let wrapperEl = this.$refs[this.dragRefName][0].$el
      const clientRect = this.checkElPosition(e, wrapperEl)
      if (!clientRect) {
        // 没有在父容器内 不用交换顺序 还原之前顺序就行
        const cycles = this.lifeCycleData[this.dragRefName]
        if (this.nextCycleMovement) {
          const index = this.lifeCycleData[this.dragRefName].findIndex(it => it.id === this.nextEvent.id)
          this.lifeCycleData[this.dragRefName].splice(index, 0, this.wrapper)
        } else {
          this.lifeCycleData[this.dragRefName].push(this.wrapper)
        }
      } else {
        const { x, y, width, height } = clientRect
        const innerY = e.clientY - y
        const childNodes = wrapperEl.childNodes
        let insertIndex = -1
        let totalH = 0
        for (let i = 0; i < childNodes.length; i++) {
          if (innerY > totalH) {
            totalH += childNodes[i].offsetHeight
            insertIndex++
          } else break
        }
        this.lifeCycleData[this.dragRefName].splice(insertIndex, 0, this.wrapper)
      }
    },
    checkElPosition(e, wrapperEl) {
      //检查鼠标在不在可drop区域内
      const { clientX, clientY } = e
      const { x, y, width, height } = wrapperEl.getBoundingClientRect()
      if (clientX > x && clientX < x + width && clientY > y && clientY < y + height) return { x, y, width, height }
      return false
    },
    setPosition(e) {
      this.left = e.clientX - 10 - this.leftFix
      this.top = e.clientY - 20 - this.topFix
    },
    removeEventListener() {
      window.removeEventListener("mousemove", this.dragMove)
      window.removeEventListener("mouseup", this.drop)
    },
    save(type) {
      console.log(type)
      this.$event
        .changeEventAttr({
          name: "lifeCycle." + type,
          value: this.lifeCycleData[type],
          event: this.tarEvent.event,
          eventName: this.tarEvent.eventNameDes,
          eventType: this.tarEvent.eventType
        })
        .then(res => {
          console.log(res)
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "success",
            message: "保存成功"
          })
        })
        .catch(err => {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "error",
            message: "保存失败"
          })
        })
    },
    getCycleName(index) {
      return index === "beforeTrigger" ? "事件触发前" : "事件触发后"
    },
    addMovement(type) {
      const res = { type: this.selectData, id: uuid.v1() }
      switch (this.selectData) {
        case "fetch":
          break
        case "delay":
          res.time = 0
          break
        case "plugin":
          res.pluginName = ""
          break
        default:
          break
      }
      this.lifeCycleData[type].push(res)
    },
    updateMovement(name, index, movement, value) {
      if (movement === "time" && (isNaN(value) || !value.length)) {
        this.lifeCycleData[name][index][movement] = 0
      } else {
        this.lifeCycleData[name][index][movement] = value
      }
    },
    initSelectOpt() {
      const { eventMovement, movementType } = this.tarEvent.event
      if (eventMovement === "component") {
        this.baseSelectOpt.push(...this.componentSelectOpt)
      }
    },
    initLifeCycleData() {
      if (!this.tarEvent.event.lifeCycle) {
        this.lifeCycleData = new EventLifeCycle()
      } else {
        this.lifeCycleData = JSON.parse(JSON.stringify(this.tarEvent.event.lifeCycle))
      }
    }
  },
  created() {
    this.initSelectOpt()
    this.initLifeCycleData()
  }
}
</script>

<style scoped>
::v-deep .el-collapse-item__header {
  height: 28px;
  margin-left: 4px;
}
::v-deep .el-collapse {
  border-radius: 8px;
}
.item {
  padding: 4px 8px;
}
.select_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.add:hover {
  cursor: pointer;
}
.item_movement_content {
  transition: all 0.5s;
}
.item_movement {
  border-radius: 4px;
  border: 1px solid gray;
  padding: 4px 4px;
  width: 100%;
}
.drag_icon {
  text-align: right;
}
.drag_icon:hover {
  cursor: pointer;
}
.set_movement_item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.movementDes {
  width: 40%;
}
.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(90px);
}
.list-leave-active {
  position: absolute;
}
.icon_box {
  text-align: right;
}
</style>
